import React from "react";
import { Box, Button } from "@mui/material";
import CustomTableWithPagination from "../../../components/customTable/CustomTable";
import CommonButton from "../../../components/CommonButton/CommonButton";
import { Card } from "../types";
import { getFormattedDate } from "../../../utils/commonFunctions";

interface CardTableProps {
  cards: Card[];
  status: "idle" | "fetching" | "success" | "error";
  onActivate: (qrcode: string) => void;
  onDeactivate: (qrcode: string) => void;
}

const CardTable: React.FC<CardTableProps> = ({
  cards,
  status,
  onActivate,
  onDeactivate
}) => {
  const columns = [
    {
      id: "MerchantId",
      label: "Merchant ID",
      minWidth: 130,
      align: "left" as const,
      format: (value: number) => value || "-"
    },
    {
      id: "QRCode",
      label: "QR Code",
      minWidth: 170,
      align: "left" as const,
      format: (value: string) => value || "-"
    },
    {
      id: "DateAllocated",
      label: "Created At",
      minWidth: 170,
      align: "left" as const,
      format: (value: string) => (value ? getFormattedDate(value) : "-")
    },
    {
      id: "IsActive",
      label: "Status",
      minWidth: 100,
      align: "left" as const,
      format: (value: number) => (
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: value === 1 ? "success.main" : "error.main",
            color: "white",
            textTransform: "none",
            minWidth: "100px",
            "&:hover": {
              backgroundColor: value === 1 ? "success.dark" : "error.dark"
            }
          }}
        >
          {value === 1 ? "Active" : "Inactive"}
        </Button>
      )
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 200,
      align: "left" as const,
      format: (_: any, row: any) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          {row?.IsActive === 1 ? (
            <CommonButton
              variant="outlined"
              color="error"
              onClick={() => onDeactivate(row?.QRCode)}
            >
              Deactivate
            </CommonButton>
          ) : (
            <CommonButton
              variant="outlined"
              color="success"
              onClick={() => onActivate(row?.QRCode)}
            >
              Activate
            </CommonButton>
          )}
        </Box>
      )
    }
  ];

  return (
    <CustomTableWithPagination
      columns={columns}
      data={cards}
      apiStatus={status}
      payloadSize={10}
      currentPage={0}
      totalCount={cards.length}
      lastEvaluatedKey={null}
      handleChangeRowsPerPage={() => {}}
      handleChangePage={() => {}}
      isShowPagination={false}
      noDataFoundMessage="No Cards Available"
    />
  );
};

export default CardTable;
